import React from 'react';
import Card from '../../components/ui/Card.jsx';
import Input from '../../components/ui/Input.jsx';
import Button from '../../components/ui/Button.jsx';
import { useApi } from '../../hooks/useApi.js';
import { apiFetch } from '../../api.js';

export default function StudentSurveys() {
  const { data, loading, error } = useApi('/api/surveys/active');
  const active = data?.active;
  const [courses, setCourses] = React.useState(['', '', '', '', '']);
  const [saving, setSaving] = React.useState(false);
  const [message, setMessage] = React.useState({ text: '', tone: 'info' });

  React.useEffect(() => {
    setMessage({ text: '', tone: 'info' });
  }, [active?.id]);

  const updateCourse = (idx) => (event) => {
    const value = event.target.value;
    setCourses((prev) => {
      const next = [...prev];
      next[idx] = value;
      return next;
    });
  };

  const handleSubmit = async () => {
    if (!active) return;
    const payloadCourses = courses.map((course) => course.trim()).filter(Boolean);
    if (payloadCourses.length === 0) {
      setMessage({ text: 'Enter at least one course.', tone: 'error' });
      return;
    }

    setSaving(true);
    setMessage({ text: '', tone: 'info' });
    try {
      await apiFetch(`/api/surveys/${active.id}/responses`, {
        method: 'POST',
        body: JSON.stringify({ courses: payloadCourses })
      });
      setMessage({ text: 'Survey submitted. Thank you!', tone: 'info' });
    } catch (err) {
      setMessage({ text: err?.message || 'Failed to submit survey.', tone: 'error' });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <h1>Surveys</h1>
          <p className="subtle">Help the department plan upcoming course demand.</p>
        </div>
      </div>

      {error ? <div className="alert error">{error}</div> : null}
      {message.text ? <div className={message.tone === 'error' ? 'alert error' : 'alert'}>{message.text}</div> : null}

      {loading ? (
        <p className="subtle">Loading survey...</p>
      ) : !active ? (
        <Card title="No Active Survey">
          <p className="subtle">There is no active survey right now. Please check back later.</p>
        </Card>
      ) : (
        <Card title={`${active.semester || active.name || 'Active Survey'} ${active.year || ''}`.trim()}>
          <p className="subtle">Enter up to five courses you want offered next semester.</p>
          <div className="form-grid">
            {courses.map((course, idx) => (
              <Input
                key={idx}
                label={`Course ${idx + 1}`}
                value={course}
                onChange={updateCourse(idx)}
                placeholder="EE 5310"
              />
            ))}
          </div>
          <div className="form-actions">
            <Button type="button" onClick={handleSubmit} disabled={saving}>
              {saving ? 'Submitting…' : 'Submit Survey'}
            </Button>
          </div>
        </Card>
      )}
    </div>
  );
}
